"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNTESFromTransportEffects = void 0;
const zod_1 = require("zod");
const serialised_eventr_date_1 = require("./serialised-eventr-date");
const start_or_end_enum_1 = require("./start-or-end-enum");
const TransportSchema = zod_1.z.object({
    _id: zod_1.z.string().optional(),
    pick_up: serialised_eventr_date_1.EventrDateFromStringSchema,
    drop_off: serialised_eventr_date_1.EventrDateFromStringSchema,
    passengers_list: zod_1.z
        .array(zod_1.z.object({
        users: zod_1.z.array(zod_1.z.object({
            option: zod_1.z.union([zod_1.z.string(), zod_1.z.number().int()]),
        })),
    }))
        .optional(),
    transport_alias: zod_1.z.string(),
    transport_type: zod_1.z.string().optional(),
    pick_up_location: zod_1.z.string().optional(),
    drop_off_location: zod_1.z.string().optional(),
    check_in: serialised_eventr_date_1.EventrDateFromStringSchema.optional(),
    booking_ref: zod_1.z.string().optional(),
    startOrEnd: start_or_end_enum_1.StartOrEndEnum,
});
/**
 * A ZodEffects that transforms the transport data into a UNTES.
 */
exports.UNTESFromTransportEffects = TransportSchema.transform((transport) => {
    const secondary = transport.startOrEnd === 'start'
        ? transport.pick_up_location
        : transport.drop_off_location;
    return {
        id: transport._id,
        section: 'transport',
        date: transport.startOrEnd === 'start'
            ? transport.pick_up
            : transport.drop_off,
        ...(transport.check_in ? { checkIn: transport.check_in } : {}),
        subSection: transport.transport_type,
        primary: transport.transport_alias,
        ...(secondary ? { secondary } : {}),
        ...(transport.booking_ref
            ? { bookingReference: transport.booking_ref }
            : {}),
        startOrEnd: transport.startOrEnd,
    };
});
